import * as React from 'react';

import ImageCharge from '@/assets/images/guide/img_charge.svg';
import ImageToretaPlusCharge from '@/assets/images/guide/img_toretaplus_charge.svg';
import { SpBr } from '@/components/layouts/Modal/Guest/style';

import {
  Container,
  ImageChargeContainer,
  ImageToretaPlusContainer,
} from './style';

export interface WelcomeDmmProps {}

const WelcomeDmmContent: React.FC<WelcomeDmmProps> = () => {
  return (
    <Container>
      <h2>DMM競輪へようこそ！</h2>
      <p>
        DMM競輪で投票するには電子マネー toreta+ <SpBr />
        （トレタプラス）をチャージします。
      </p>
      <ImageToretaPlusContainer>
        <img src={ImageToretaPlusCharge} alt="toretapluscharge" />
      </ImageToretaPlusContainer>
      <p>
        toreta+ チャージは様々な決済手段に対応して
        <SpBr />
        います。
      </p>
      <ImageChargeContainer>
        <img src={ImageCharge} alt="charge" />
      </ImageChargeContainer>
    </Container>
  );
};

export default WelcomeDmmContent;
